<div class="star-container">
    <div *ngFor="let star of starArray">
        <app-svg-icon name="{{star}}"></app-svg-icon>
    </div>
</div>